// extracted by mini-css-extract-plugin
module.exports = {"link":"mdx-remote-view_link__WPDSh"};